<template lang="pug">
div
    v-dialog(v-model="isShowModal_" @close="isShowModal_=false" width="1200")
        v-card
            v-card-title(class="elevation-1") 
                | Detalle  
                v-spacer
                v-btn(icon @click="isShowModal_=false")   
                    v-icon mdi-close
            v-container( fluid)         
                    v-col( cols="12" sm="12" md="12")
                            v-data-table(
                                :headers="tableHeader"
                                :items="tableFilteredInfo"
                                class="elevation-2"
                                :loading="!tableFilteredInfo.length"
                                height="400"
                                fixed-header 
                               hide-default-header
                            ) 
                                template(  v-slot:header="{ props }") 
                                    th(v-for="(column,index) in props.headers" :key="index")
                                        v-autocomplete( 
                                                    v-if="column.value!='IdGoal'"
                                                    :items="columnValueList(column.value)"
                                                    hide-details="auto"
                                                    v-model="filters[column.value]"
                                                    clearable
                                                    dense
                                                    :label="column.text"
                                                    outlined) 
                                template( v-slot:item.IdGoal="{ item }")
                                    td  
                                        v-icon.fa.fa-edit(elevation="10" color="info" @click="sendInfo(item)")   
                                            


</template>
<script> 
export default {
    props:{
        tablaInfo:Array,
        parameter:Object,
        IsShowModal:Boolean

    }, 
    data(){
        return{ 
            tableHeader:[
                        {text:'Usuario',value:'NameUser'},
                        {text:'Documento',value:'NameDocType'},
                        {text:'Categoria',value:'NameCategory'},
                        {text:'Frecuencia',value:'NameFrequency'},
                        {text:'Mes',value:'Month'},
                        {text:'Periodo',value:'Period'},
                        {text:'Cantidad',value:'Quantity'},
                        {text:'Estado', value:'ActiveName'},
                        {text:'Editar',value:'IdGoal'},
                        ],
            filters:{}
        }
    },
    watch : {
        tablaInfo : function(newValue,oldValue){
            console.log("Valor nuevo")
            console.log(newValue)
             console.log("Valor antiguo")
            console.log(oldValue)
        }
    },
    computed:{
        isShowModal_ :{
                        get(){return this.IsShowModal },
                        set(val){this.$emit("update:IsShowModal",val)}
        } ,
        tableFilteredInfo() {
            return this.tablaInfo.filter(d => {
            return Object.keys(this.filters).every(f => {
                if(this.filters[f]==null)
                return filters
                else{ 
                return this.filters[f].toString().length < 1 || this.filters[f].toString().includes(d[f].toString())
                }

            })
            })
      }
    },
    methods:{ 
            columnValueList(val) {
                return this.tableFilteredInfo.map(d => d[val])
            }, 
            sendInfo(item){  
                this.$emit("sendInfo", Object.assign({}, item)) 
            }
    }
}
</script>
<style>
    .table-fade-enter-active {
      transition: all .5s ease;
    }
    .table-fade-leave-active {
      transition: all .5s ease;
    }
    .table-fade-enter, .table-fade-leave-to{
      transform: translateY(-20px);
      opacity: 0;
    } 
</style>